import { Document } from '../../jurisdiction/jurisdiction.domain';
import { ElectricalGenerator } from './electricalGenerator';
import { EnergyProducer } from './energyProducer';
import { GridPowerPlantProtection } from './gridPowerPlantProtection';
import { PhotovoltaicModule } from './photovoltaicModule';
import { PowerInverter } from './powerInverter';
import { StorageData } from './storageData';
import { StoragePowerConverter } from './storagePowerConverter';
import { StorageUnit } from './storageUnit';
import { GridApplicationDocumentTypes } from './enums/grid-application-document-types.enum';
import { TechnicalSpecificationsSectionsState } from './sections-state/technicalSpecificationsSectionsState';

export class TechnicalData {
  constructor() {
    this.existing_energy_producers = [new EnergyProducer(null, null, true)];
    this.grid_power_plant_protection_data = new GridPowerPlantProtection();
    this.photovoltaic_modules = [new PhotovoltaicModule()];
    this.power_inverters = [new PowerInverter()];
    this.generators = [new ElectricalGenerator()];
    this.storages = [new StorageUnit()];
    this.power_converters = [new StoragePowerConverter()];
    this.circuit_diagram = new Document(GridApplicationDocumentTypes.CircuitDiagram);
    this.document_ids_for_deletion = [];
  }

  application_id: number;
  has_power_storage: boolean;
  has_energy_producer: boolean;
  electrical_feed_type: string;
  black_start_capability: boolean;
  io_planned: boolean;
  ess_planned: boolean;
  type_of_feed_in: string;
  type_of_complete_feed_in: string;
  feed_in_management: string;
  measuring_concept: string;
  meter_operation: string;
  meter_operator: string;
  existing_energy_producers: EnergyProducer[];
  total_power_pv_modules: number;
  photovoltaic_modules: PhotovoltaicModule[];
  total_power_inverters: number;
  power_inverters: PowerInverter[];
  total_power_generators: number;
  generators: ElectricalGenerator[];
  circuit_diagram: Document;
  storage_data: StorageData;
  storages: StorageUnit[];
  power_converters: StoragePowerConverter[];
  grid_power_plant_protection_data: GridPowerPlantProtection;
  document_ids_for_deletion: number[];
  list_of_data_points: Document = new Document(GridApplicationDocumentTypes.ListOfDataPoints);

  technical_specifications_sections_state: TechnicalSpecificationsSectionsState;
}
